module.exports = __webpack_public_path__ + "img/blog-04.0843f5ab.jpg";